export const PRODUCT_CATEGORIES = [
  "body", "brakes", "electrical", "engine", "filters_fluids", "drivetrain", "exhaust",
  "suspension_steering", "wheels_tires", "interior", "glass", "fasteners",
  "tools_consumables", "other",
];

export function categoryLabel(t, category) {
  return category ? t(`products.categories.${category}`) : "—";
}
